interface TagLike {
  id?: string;
  name?: string;
  color?: string;
}

interface CropZoneLike {
  tags?: (string | TagLike)[];
  flags?: (string | TagLike)[];
}

/**
 * Crop zone tag associations arrive in two different shapes depending on the endpoint:
 * `GET /base/cropzone/{id}` returns `tags` as an array of id strings, while the bulk
 * properties list returns `flags` as an array of tag objects. Both are read here so the
 * caller does not have to care which endpoint supplied the crop zone.
 */
const toIds = (source?: (string | TagLike)[]): string[] =>
  (source ?? [])
    .map(entry => (typeof entry === 'string' ? entry : entry?.id))
    .filter((id): id is string => Boolean(id));

const getCropZoneTagIds = (cropZone?: CropZoneLike | null): string[] => {
  // First non-empty wins, not first non-nullish: a response carrying both keys
  // can have an empty `tags` alongside a populated `flags`, and treating that as
  // "no tags" would wipe them on the next save.
  const fromTags = toIds(cropZone?.tags);

  return fromTags.length > 0 ? fromTags : toIds(cropZone?.flags);
};

export default getCropZoneTagIds;
